<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="studentTrackingDetail"
    class="m-edition-billing-student-tracking-detail"
  >

    <!-- Ultimo login -->
    <h3 class="student-tracking-section-title">
      {{ $t('mEditionBillingStudentTrackingDetail.sections.lastLogin') }}
    </h3>
    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr>
          <th class="text-align-left" width="30%">
            {{ $t('mEditionBillingStudentTrackingDetail.labels.email') }}
          </th>
          <th class="text-align-center" width="30%">
            {{ $t('mEditionBillingStudentTrackingDetail.labels.lastLogin') }}
          </th>
          <th class="text-align-center" width="20%">
            {{ $t('mEditionBillingStudentTrackingDetail.labels.ip') }}
          </th>
          <th class="text-align-center" width="20%">
            {{ $t('mEditionBillingStudentTrackingDetail.labels.origin') }}
          </th>
        </tr>
        <tr class="row-data">
          <td class="text-align-left">
            {{ ultimoLogin && ultimoLogin.email ? ultimoLogin.email : ' - ' }}
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span v-if="ultimoLogin && ultimoLogin.ultimo_login">
              {{ $moment.parseZone(ultimoLogin.ultimo_login).format('D MMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTrackingDetail.labels.never') }}
            </span>
          </td>
          <td class="text-align-center">
            {{ ultimoLogin && ultimoLogin.ultimo_login_ip ? ultimoLogin.ultimo_login_ip : ' - ' }}
          </td>
          <td class="text-align-center">
            {{ ultimoLogin && ultimoLogin.ultimo_login_origen !== null
              ? getOrigenText(ultimoLogin.ultimo_login_origen)
              : ' - ' }}
          </td>
        </tr>
      </table>
    </div>

    <!-- Progreso por proyecto -->
    <h3 class="student-tracking-section-title">
      {{ $t('mEditionBillingStudentTrackingDetail.sections.projects') }}
    </h3>
    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="inscripciones.length">
          <th class="text-align-left" width="24%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thProject') }}
          </th>
          <th class="text-align-center" width="14%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thCurrent') }}
          </th>
          <th class="text-align-center" width="16%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thLastAccess') }}
          </th>
          <th class="text-align-center" width="16%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thLastSeen') }}
          </th>
          <th class="text-align-center" width="14%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thProgress') }}
          </th>
          <th class="text-align-center" width="16%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.projects.thState') }}
          </th>
        </tr>
        <template v-for="(grupo, gIndex) in inscripcionesPorAcademia">
          <tr
            :key="`academia-${gIndex}`"
            class="student-tracking-academy-row"
          >
            <td
              colspan="6"
              class="text-align-left"
            >
              <span class="font-weight-bold">
                <i class="fas fa-university margin-right-xsmall"></i>
                {{ grupo.academia_nombre }}
              </span>
              <small class="font-weight-regular text-color-black-55">
                · {{ grupo.academia_url }} · {{ grupo.academia }}
              </small>
            </td>
          </tr>
          <tr
            v-for="(inscripcion, index) in grupo.inscripciones"
            :key="`inscripcion-${gIndex}-${index}`"
            class="row-data"
          >
          <td class="text-align-left">
            <span class="display-flex-column">
              <span class="ellipsis">{{ inscripcion.proyecto_titulo }}</span>
              <small
                :class="inscripcion.acceso_activo
                  ? 'font-weight-regular text-color-success'
                  : 'font-weight-regular text-color-danger'"
              >
                {{ inscripcion.acceso_activo
                  ? $t('mEditionBillingStudentTrackingDetail.labels.accessActive')
                  : $t('mEditionBillingStudentTrackingDetail.labels.accessInactive') }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            <span
              :class="inscripcion.vigente
                ? 'font-weight-bold text-color-success'
                : 'font-weight-regular'"
            >
              {{ inscripcion.vigente
                ? $t('mEditionBillingStudentTrackingDetail.labels.current')
                : $t('mEditionBillingStudentTrackingDetail.labels.notCurrent') }}
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span v-if="inscripcion.ultimo_acceso">
              {{ $moment.parseZone(inscripcion.ultimo_acceso).format('D MMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTrackingDetail.labels.never') }}
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span v-if="inscripcion.ultimo_visto">
              {{ $moment.parseZone(inscripcion.ultimo_visto).format('D MMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTrackingDetail.labels.never') }}
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span class="display-flex-column">
              <span>{{ inscripcion.nodos_vistos }}/{{ inscripcion.nodos_totales }} · {{ inscripcion.porcentaje }}%</span>
              <small
                v-if="inscripcion.nodos_activos"
                class="font-weight-regular"
              >
                {{ $t('mEditionBillingStudentTrackingDetail.labels.progressActive') }}
                {{ inscripcion.nodos_vistos }}/{{ inscripcion.nodos_activos }} · {{ inscripcion.porcentaje_activos }}%
              </small>
            </span>
          </td>
          <td class="text-align-center">
            <span
              v-if="inscripcion.completado"
              class="display-flex-column"
            >
              <span class="font-weight-bold text-color-success">
                {{ $t('mEditionBillingStudentTrackingDetail.labels.completed') }}
              </span>
              <small
                v-if="inscripcion.fecha_completado"
                class="font-weight-regular"
              >
                {{ $moment.parseZone(inscripcion.fecha_completado).format('D MMM YYYY') }}
              </small>
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTrackingDetail.labels.inProgress') }}
            </span>
          </td>
          </tr>
        </template>
      </table>
      <p
        v-show="!inscripciones.length"
        class="text-align-center"
      >
        {{ $t('mEditionBillingStudentTrackingDetail.labels.noProjects') }}
      </p>
    </div>

    <!-- Ingresos a academias (staff) -->
    <template v-if="academias.length">
      <h3 class="student-tracking-section-title">
        {{ $t('mEditionBillingStudentTrackingDetail.sections.academies') }}
      </h3>
      <div class="m-table-primary">
        <table class="table-layout-fixed">
          <tr>
            <th class="text-align-left" width="40%">
              {{ $t('mEditionBillingStudentTrackingDetail.table.academies.thAcademy') }}
            </th>
            <th class="text-align-center" width="30%">
              {{ $t('mEditionBillingStudentTrackingDetail.table.academies.thRole') }}
            </th>
            <th class="text-align-center" width="30%">
              {{ $t('mEditionBillingStudentTrackingDetail.table.academies.thLastAccess') }}
            </th>
          </tr>
          <tr
            v-for="(academia, index) in academias"
            :key="index"
            class="row-data"
          >
            <td class="text-align-left">
              <span class="display-flex-column">
                <span class="ellipsis">{{ academia.academia_nombre }}</span>
                <small class="font-weight-regular">{{ academia.academia_url }}</small>
              </span>
            </td>
            <td class="text-align-center">
              {{ academia.actor_tipo !== null ? $filters.getActorValue(academia.actor_tipo, 'name') : ' - ' }}
            </td>
            <td class="text-align-center text-white-space-nowrap">
              {{ $moment.parseZone(academia.ultimo_acceso).format('D MMM YYYY HH:mm') }}
            </td>
          </tr>
        </table>
      </div>
    </template>

    <!-- Historial de logins -->
    <h3 class="student-tracking-section-title">
      {{ $t('mEditionBillingStudentTrackingDetail.sections.loginsHistory') }}
    </h3>
    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="logins.length">
          <th class="text-align-left" width="24%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.logins.thDate') }}
          </th>
          <th class="text-align-center" width="18%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.logins.thIp') }}
          </th>
          <th class="text-align-center" width="18%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.logins.thOrigin') }}
          </th>
          <th class="text-align-center" width="24%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.logins.thDomain') }}
          </th>
          <th class="text-align-center" width="16%">
            {{ $t('mEditionBillingStudentTrackingDetail.table.logins.thResult') }}
          </th>
        </tr>
        <tr
          v-for="(login, index) in logins"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left text-white-space-nowrap">
            {{ $moment.parseZone(login.fecha).format('D MMM YYYY HH:mm:ss') }}
          </td>
          <td class="text-align-center">
            {{ login.ip ? login.ip : ' - ' }}
          </td>
          <td class="text-align-center">
            {{ getOrigenText(login.origen) }}
          </td>
          <td class="text-align-center">
            <span class="ellipsis">{{ login.frontend_domain ? login.frontend_domain : ' - ' }}</span>
          </td>
          <td class="text-align-center">
            <span
              :class="login.resultado
                ? 'font-weight-regular text-color-success'
                : 'font-weight-regular text-color-danger'"
            >
              {{ login.resultado
                ? $t('mEditionBillingStudentTrackingDetail.labels.success')
                : $t('mEditionBillingStudentTrackingDetail.labels.failure') }}
            </span>
          </td>
        </tr>
      </table>
      <p
        v-show="!logins.length"
        class="text-align-center"
      >
        {{ $t('mEditionBillingStudentTrackingDetail.labels.noLogins') }}
      </p>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingStudentTrackingDetail',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academias: [],

      filter: {
        limite: 10,
        pagina: 1
      },

      inscripciones: [],

      logins: [],

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      showLoadingState: true,

      ultimoLogin: null,

      usuarioId: ''
    }
  },

  computed: {
    inscripcionesPorAcademia () {
      const grupos = []

      this.inscripciones.forEach(inscripcion => {
        let grupo = grupos.find(g => g.academia === inscripcion.academia)

        if (!grupo) {
          grupo = {
            academia: inscripcion.academia,
            academia_nombre: inscripcion.academia_nombre,
            academia_url: inscripcion.academia_url,
            inscripciones: []
          }
          grupos.push(grupo)
        }

        grupo.inscripciones.push(inscripcion)
      })

      return grupos
    }
  },

  created () {
    this.usuarioId = this.$route.params.thirdid
    this.readTrackingResumen()
    this.readTrackingLogins()
  },

  methods: {
    getOrigenText (origen) {
      return origen === 1
        ? this.$t('mEditionBillingStudentTrackingDetail.labels.originClassroom')
        : this.$t('mEditionBillingStudentTrackingDetail.labels.originLogin')
    },

    readTrackingResumen () {
      this.$services.read('tracking', 'readTrackingUsuarioResumen', {}, [this.usuarioId])
        .then(response => {
          this.ultimoLogin = response.data.ultimo_login
          this.inscripciones = response.data.inscripciones
          this.academias = response.data.academias || []
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
          this.$alerts.pushAlert('mEditionBillingStudentTrackingDetail', 'readTrackingResumen', 'error', 'a-alert-danger')
        })
    },

    readTrackingLogins () {
      this.pagination.showLoadingState = true
      this.$services.read('tracking', 'readTrackingUsuarioLogins', {}, [this.usuarioId], this.filter)
        .then(response => {
          this.logins = response.data.data
          this.pagination.currentQuantity = this.logins.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.logins = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.$alerts.pushAlert('mEditionBillingStudentTrackingDetail', 'readTrackingLogins', 'error', 'a-alert-danger')
        })
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readTrackingLogins()
    }
  }
}
</script>
